import { useLastPathSegment } from 'shared/hooks'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { type TollFreeRoutes } from 'pages/settings/pages/compliance/pages/tollFree'

export const useProgressInfoTitle = () => {
  const {
    tollFreeNavigationStore: { getProgressInfoTitle },
  } = useTollFreeStepsContext()

  return getProgressInfoTitle(useLastPathSegment() as TollFreeRoutes)
}
